<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">人员名称:</div>
                <el-input v-model="conditionData.Name" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">电话:</div>
                <el-input v-model="conditionData.Phone" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">所属公司:</div>
                <!-- <el-select v-model="conditionData.MechanismIds" multiple placeholder="请选择" size="small">
                    <el-option
                    v-for="item in mechanismList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select> -->
                <el-input v-model="mechanismName" size="small" placeholder="请选择" disabled></el-input>
                <el-button type="primary" size="small" @click="mechanismDialog=true">选择机构</el-button>

            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="warning" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogShow()">新建</el-button>
                    <el-button type="success" size="small" icon="el-icon-download" @click="downloadExcel">导出数据</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                type="selection"
                width="80"
                align="center"
                >
                </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="用户名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="phone"
                label="用户电话"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="account"
                label="账号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="roleNames"
                label="关联角色"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="mechanismName"
                label="所属公司"
                align="center"
                width="300px"
                >
                </el-table-column>
                <el-table-column
                prop="enable"
                label="是否启用"
                align="center"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.enable">启用</span>
                    <span v-else>禁用</span>
                </template>
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="100px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button>
                    <!-- <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteUser(scope.row)">删除</el-button> -->
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增用户" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户名称:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        用户电话:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.phone" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        账号:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.account" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        密码:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.password" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        角色:
                    </div>
                    <div class="input">
                        <el-select v-model="roleIds" multiple size="small" placeholder="请选择" class="input" @change="roleIdsChange">
                            <el-option
                            v-for="item in roleList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        所属机构:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.mechanismName" size="small" placeholder="请选择" disabled></el-input>
                        <el-button type="primary" size="small" @click="mechanismDialog=true">选择机构</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        所属保司:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.companyName" size="small" placeholder="请选择" disabled></el-input>
                        <el-button type="primary" size="small" @click="companyDialog=true">选择保司</el-button>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        创建人:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.creator" size="small" placeholder="请输入"></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        是否启用:
                    </div>
                    <el-select v-model="addData.enable" placeholder="请选择" size="small" class="input">
                        <el-option
                        v-for="item in enableList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-check" size="small" @click="addUser">提交</el-button>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑用户" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户名称:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        用户电话:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.phone" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        账号:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.account" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        密码:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.password" size="small" placeholder="不修改密码请不要填写"></el-input>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        角色:
                    </div>
                    <div class="input">
                        <!-- <el-input v-model="role" size="small" placeholder="请选择"></el-input>
                        <el-button type="primary" size="small" @click="roleDialog = true">选择角色</el-button> -->
                        <el-select v-model="roleIds" size="small" multiple placeholder="请选择" class="input" @change="roleIdsChange">
                            <el-option
                            v-for="item in roleList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
             
                <div class="item">
                    <div class="label">
                        所属机构:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.mechanismName" size="small" placeholder="请选择" disabled></el-input>
                        <el-button type="primary" size="small" @click="mechanismDialog=true">选择机构</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        所属保司:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.companyName" size="small" placeholder="请选择" disabled></el-input>
                        <el-button type="primary" size="small" @click="companyDialog=true">选择保司</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        是否启用:
                    </div>
                    <el-select v-model="updateData.enable" placeholder="请选择" size="small" class="input">
                        <el-option
                        v-for="item in enableList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-check" size="small" @click="updateUser">提交</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="roleDialog" title="角色选择" width="800px">
            <div class="table">
                <el-table
                    :data="roleList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    prop="name"
                    label="角色名称"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="code"
                    label="角色编码"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="120px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="selectRole(scope.row)">选择角色</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                    @current-change="handleRolePageChange"
                        background
                        layout="prev, pager, next, total"
                        :total="roleTotalCount"
                        :current-page="rolePage"
                        :page-size="rolePageSize">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="mechanismDialog" title="机构选择" width="1000px">
            <div class="table">
                <el-table
                    :data="mechanismList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    prop="name"
                    label="机构名称"
                    align="center"
                    width="200px"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="所属省份"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="city"
                    label="所属市级"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="district"
                    label="所属片区"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="120px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="selectMechanism(scope.row)">选择机构</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                    @current-change="handleMechanismPageChange"
                        background
                        layout="prev, pager, next, total"
                        :total="mechanismTotalCount"
                        :current-page="mechanismPage"
                        :page-size="mechanismPageSize">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="companyDialog" title="保司选择" width="600px">
            <div class="table">
                <el-table
                    :data="companyList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    prop="name"
                    label="保司名称"
                    align="center"
                    >
                   
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="120px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="selectCompany(scope.row)">选择保司</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                    @current-change="handleCompanyPageChange"
                        background
                        layout="prev, pager, next, total"
                        :total="companyTotalCount"
                        :current-page="companyPage"
                        :page-size="companyPageSize">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
        
    </div>
</template>
<script>
import api from '../../../api/main'
export default {
    name: 'person',
    data () {
        return {
            gandenList:[
                {
                    value:'1',
                    label:'男'
                }
            ],
            enableList:[
                {
                    value:true,
                    label:'启用'
                },{
                    value:false,
                    label:'禁用'
                }
            ],
            isShow:false,
            totalCount:0,
            isUpdateDialog:false,
            updateData:{}, 
            conditionData:{
                MechanismIds:[],
                companyIds:[],
                Name:'',
                Phone:'',
                page:1,
                pageSize:10,
            },
            tableData:[],
            isAddDialog:false,
            addData:{
                ganden:2,
            },
            roleIds:[],
            roleList:[],
            rolePage:1,
            rolePageSize:20,
            roleDialog:false,
            roleTotalCount:0,

            mechanismList:[],
            mechanismDialog:false,
            mechanismTotalCount:0,
            mechanismPage:1,

            mechanismName:'',




            companyList:[],
            companyDialog:false,
            companyTotalCount:0,
            companyPage:1,
            companyName:'',



        }
    },
    created(){

    },
    mounted(){
        this.loadingData();
        this.queryRole();
        this.queryMechanismList();
        this.QueryCompanyList();

    },
    methods:{
        
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.QueryUsers(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        selectRole(row){
            this.role = row.name
            this.roleDialog = false;
            if(this.isAddDialog){
                this.addData.roleId = row.id
            }else if(this.isUpdateDialog){
                this.updateData.roleId = row.id
            }
        },
       
        handleRolePageChange(page){
            this.rolePage = page;
            this.queryRole();
        },
        
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        handleMechanismPageChange(page){
            this.mechanismPage = page;
            this.queryMechanismList();
        },
        handleCompanyPageChange(page){
            this.companyPage = page;
            this.QueryCompanyList();
        },
        // 编辑用户
        isUpdateDialogShow(row){
            this.organization = row.mechanismName;
            this.role = row.roleName;
            this.updateData = row;
            this.roleIds = this.updateData.roleIds.split(',')
            this.isUpdateDialog = true;
        },
        // 重置
        reset(){
            this.mechanismName = '';
            this.conditionData = {
                MechanismIds:[],
                Name:'',
                Phone:'',
                page: 1,
                pageSize: 10,
            },
            this.loadingData();
        },
        // 弹出新建
        addDialogShow(){
            this.addData={};
            this.role='';
            this.isAddDialog = true;
            this.roleIds = [];
        },
        // 添加用户
        async addUser(){
            for(let i in this.roleIds){
                if(i==0){
                    this.addData.roleIds = this.roleIds[i];
                }else{
                    this.addData.roleIds = this.addData.roleIds + ','+this.roleIds[i];
                }
            }
 
            let res  = await api.CreateUser(this.addData);
            if(res.data.code == '200'){
                this.isAddDialog = false;
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                });
                this.roleIds = [];
                this.selectData();
            }
        },
        // 新增用户
        async updateUser(){
            console.log(this.updateData);
            for(let i in this.roleIds){
                if(i==0){
                    this.updateData.roleIds = this.roleIds[i];
                }else{
                    this.updateData.roleIds = this.updateData.roleIds + ','+this.roleIds[i];
                }
            }
            let res  = await api.UpdateUser(this.updateData);
            if(res.data.code == '200'){
                this.isUpdateDialog = false;
                this.$message({
                    type: 'success',
                    message: '更新成功!'
                });
                this.roleIds = [];
                this.selectData();
            }
        },
        // 角色列表
        async queryRole(){
            let res  = await api.QueryRole({page:this.rolePage, pageSize:20});
            console.log(res);
            this.roleList = res.data.data.data;
            this.roleTotalCount = res.data.data.totalCount;
        },
        
        // 删除角色
        deleteUser(row){
            console.log(row);
            let _this = this;
            this.$confirm('将删除选中的用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.deleteAsyncU(row.id);
                
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        async deleteAsyncU(id){
            let res = await api.DeleteAsyncU(id);
            if(res.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.selectData();
            }
        },


        async queryMechanismList(){
            let res  = await api.QueryMechanism({page:this.mechanismPage, pageSize:10});
            this.mechanismList = res.data.data.data;
            this.mechanismTotalCount = res.data.data.totalCount;
        },
        
        async QueryCompanyList(){
            let res  = await api.queryCompanyPage({page:this.companyPage, pageSize:10});
            this.companyList = res.data.data.data;
            console.log(res.data.data.data);
            console.log(this.companyList);
            this.companyTotalCount = res.data.data.totalCount;
        },
        selectMechanism(row){
            if(this.isAddDialog){
                this.addData.mechanismId = row.id;
                this.addData.mechanismName = row.name;
            }else if(this.isUpdateDialog){
                this.updateData.mechanismId = row.id;
                this.updateData.mechanismName = row.name;
            }else{
                this.conditionData.MechanismIds = [row.id];
                this.mechanismName = row.name;
            }
            this.mechanismDialog = false;
        },

        selectCompany(row){
            if(this.isAddDialog){
                this.addData.companyId = row.id;
                this.addData.companyName = row.name;
            }else if(this.isUpdateDialog){
                this.updateData.companyId = row.id;
                this.updateData.companyName = row.name;
            }else{
                this.conditionData.companyIds = [row.id];
                this.companyName = row.name;
            }
            this.companyDialog = false;
        },

        roleIdsChange(list){
            let name = '';
            for(let i in list){
                for(let j in this.roleList){
                    if(list[i] == this.roleList[j].id){
                        if(name){
                            name = name+','+this.roleList[j].name
                        }else{
                            name = this.roleList[j].name
                        }
                        break;
                    }
                }
            }
            if(this.isUpdateDialog){
                this.updateData.roleNames = name;
            }else{
                this.addData.roleNames = name;
            }
        },
        async downloadExcel(){
            let conditionData = {
                MechanismIds:this.conditionData.MechanismIds,
                Name:this.conditionData.Name,
                Phone:this.conditionData.Phone,    
            }
           
            let res = await api.exportInventory({
                "type": 10,
                "Condition":conditionData
                
            },'人员信息');
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        // overflow: scroll;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 120px;
                margin-bottom: 5px;
            }
            .input{
                width: 315px;
                display: flex;
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            flex-direction: row-reverse;
            .el-button{
                margin-right: 10px;
            }
        }
        /deep/.el-input.is-disabled .el-input__inner{
            color:#606266
        }
    }
</style>
